import React, { Component } from 'react';
import axios from 'axios';
import Swal from "sweetalert2/dist/sweetalert2";

import MenuList from '../Menu';
import InputRows from './InputRows';
import Links from './Links';

import { menu, bimPageText, swalText } from '../../../Constants';

import './bim.scss';

export default class BIMClass extends Component {
    constructor(props){
        super(props);

        this.state = {
            links: {},
            initialized: false,
        };

        document.title = menu[1].text;
    }

    componentDidMount() {
        axios.post('/api/check').then(async result => {
            if (result.data.message !== 'you Were authorized') {
                this.props.history.push('/admin');
                return;
            }

            try {
                const { data: { status, data } } = await axios.post('/api/bim/getYoutubeLinks');

                if (status) {
                    this.setState({
                        links: data,
                        initialized: true,
                    });
                }
            } catch (e) {
                console.log(e);
            }
        }).catch(res => {
            if (res) {
                this.props.history.push('/admin');
            }
        });
    }

    change = newBim => {
        let { bim } = this.state;

        bim.forEach((el, index) => {
            if (el.id === newBim.id)
                bim[index] = newBim;
        });

        this.setState({ bim })
    };

    addBim = async obj => {
        const { data: { status, data: res } } = await axios.put('/api/bim/addLink', obj);

        if (status) {
            Swal.fire({
                type: 'success',
                title: 'Հղումն ավելացավ',
            });

            const { links } = this.state;

            if (!links[obj.lang]) {
                links[obj.lang] = [];
            }

            links[obj.lang].push({
                ...obj,
                id: res.id,
                link: obj.uri,
                image: res.image,
            });

            this.setState({ links });
        }
    };

    deleteLink = async (id, lang) => {
        const { links } = this.state;
        const { value } = await Swal.fire({
            type: 'question',
            title: swalText.del,
            showCloseButton: true,
            showCancelButton: true,
            text: swalText.delMore,
            confirmButtonText: swalText.yes,
            cancelButtonText: swalText.cancel,
        });
        let newLinks;

        if (value) {
            const { data: { status } } = await axios.delete(`/api/bim/deleteLink/${id}`);

            if (status) {
                newLinks = links[lang].filter(link => link.id !== id);

                Swal.fire({
                    type: 'success',
                    title: 'Հղումն ջնջվեց',
                });

                this.setState(prevState => ({
                    ...prevState,
                    links: {
                        ...prevState.links,
                        [lang]: newLinks,
                    }
                }));
            }
        }
    };

    render() {
        const { initialized, links } = this.state;

        if (!initialized) return null;

        const { history } = this.props;

        return (
            <div id='bimPage'>
                <MenuList history={history} />
                <div id='right'>
                    <header><h1>{menu[1].text}</h1></header>
                    <div id='formRight'>
                        {bimPageText.map(text => (
                            <InputRows
                                {...text}
                                key={text.lang}
                                addBim={this.addBim}
                            />
                        ))}
                    </div>
                    <div id='showAll'>
                        <h3><em>Բոլոր հղումները</em></h3>
                        <div id='links'>
                            {Object.keys(links).map(lang => (
                                <>
                                    <h3><em>{lang}</em></h3>
                                    <Links
                                        key={lang}
                                        header={lang}
                                        data={links[lang]}
                                        deleteLink={this.deleteLink}
                                    />
                                </>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
